import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DiscountImage from '../../assets/images/3d-icons/discount.png';
import i18n from '../../i18n';

interface DiscountChipProps {
  discount: number;
  toolTipEnabled?: boolean;
}
export default function DiscountChip({ discount, toolTipEnabled = false }: DiscountChipProps): React.JSX.Element {
  const percentFormatter = new Intl.NumberFormat(i18n.resolvedLanguage, { style: 'percent', maximumFractionDigits: 2 });
  const { t } = useTranslation('common');

  return (
    <Tooltip title={t('contracts:discount')} disableHoverListener={!toolTipEnabled}>
      <Chip variant="tag" color="primaryContainer" label={`-${percentFormatter.format(discount)}`} icon={<img src={DiscountImage} height="20" width="20" />} />
    </Tooltip>
  );
}
